<router-outlet></router-outlet>
<app-registra-modal></app-registra-modal>

<div *ngIf="loading$ | async" class="loading-overlay">
  <div class="loading-spinner"></div>
</div>